import React from 'react';
import PropTypes from 'prop-types';
import { 
  HomeFilled, 
  DashboardFilled, 
  ApiFilled, 
  SignalFilled, 
  ProfileFilled, 
  PieChartFilled, 
  MergeFilled, 
  SettingFilled, 
  CalculatorFilled, 
  UserOutlined,
  UsergroupAddOutlined,
  FileTextFilled,
  SafetyCertificateFilled,
  ApartmentOutlined
} from '@ant-design/icons';
import chainIcon from "./assets/chain.png"
import './PageTitle.css';

const iconMap = {
  home: <HomeFilled />,
  dashboard: <DashboardFilled />,
  assets: <ApiFilled />,
  dependencies: <img src={chainIcon} alt="Dependencias" style={{ width: 20, height: 20 }} />,
  controls: <ProfileFilled />,
  assignment: <MergeFilled />,
  evaluation: <CalculatorFilled />,
  gaps: <PieChartFilled />,
  tasks: <FileTextFilled />,
  processes: <ApartmentOutlined />,
  settings: <SettingFilled />,
  userprofile: <UserOutlined />,
  usermanagement: <UsergroupAddOutlined />,
  licences: <SafetyCertificateFilled />
};

const PageTitle = ({ title, icon }) => {
  return (
    <div className="page-title-container">
      <span className="page-title-icon">{iconMap[icon]}</span>
      <h1 className="page-title">{title}</h1>
    </div>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default PageTitle;
